import React from "react";
import { Box } from "@mui/material";
import Header from "components/Header";
import UserTable from "./UserTable";
const UserList = () => {
  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title={"Users"}
        subtitle="Contains data related to Users"
      />
      <UserTable />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={2}
      ></Box>
    </Box>
  );
};

export default UserList;
